import { Navigate, Outlet } from 'react-router-dom';
import React from 'react';

import { useUserProfileUIStore } from '@core/useStores';
import { RoutePaths } from '@core/routes/RoutePaths';

export const AnonymousRoute = () => {
    const userProfileUIStore = useUserProfileUIStore();


    return (userProfileUIStore.isAuthentificated
        ? <Navigate to={{ pathname: RoutePaths.root }} replace/>
        : <Outlet /> );
}
